//When we do for DRMS, we would look at the data type that comes from schema api to determine type of search
//In back end should probably make greater than do max time and less than do max time
export function createSearchObject(searchParamsObjArray, sort = undefined, docType, state, county) {
  let systemFolders = JSON.parse(sessionStorage.getItem('SystemColumns'));

  let metadataSearchObject = {
    searchCriteria: [],
    sort: [],
    // FileSeries removed
    aggregation: [
      'object_specific.contextID',
      'object_specific.smc_department',
      'object_specific.' + systemFolders[0].name.replace(/\s/g, ''),
      'object_specific.' + systemFolders[1].name.replace(/\s/g, ''),
    ],
    conjunction:'AND',
  };
  searchParamsObjArray.forEach((param) => {
    let condition;
    //For DRMS, we would check if data type is boolean, do EQUALS. Else use CONTAINS
    if (param.key === 'is_reviewed' || param.key === 'is_corrected' || param.key === 'internal_review_required') {
      condition = 'EQUALS';
    } else {
      condition = 'CONTAINS';
    }
    if (param.key === 'Producer Identified') {
      metadataSearchObject.searchCriteria.push({
        condition: condition,
        field1: {
          name: '*core_customer_id',
          value: [param.core_customer_id],
        },
      });
    } else {
      metadataSearchObject.searchCriteria.push({
        condition: param.value === '' ? 'NOT_EXISTS' : condition,
        field1: {
          name: param.key.replace(' ', ''),
          value: [param.value],
        },
      });
    }
  });

  if (docType && docType.length !== 0) {
    metadataSearchObject.searchCriteria.push({
      condition: 'EQUALS',
      field1: {
        name: 'object_type.object_type_name',
        value: [docType.objectTypeName],
      },
    });
  }

  if (state && state.length !== 0) {
    metadataSearchObject.searchCriteria.push({
      condition: 'EQUALS',
      field1: {
        name: 'object_specific.state_name',
        value: [state.name],
      },
    });
  }

  if (county && county.length !== 0) {
    metadataSearchObject.searchCriteria.push({
      condition: 'EQUALS',
      field1: {
        name: 'object_specific.county_name',
        value: [county.name],
      },
    });
  }

  if (sort !== undefined && sort.length > 0) {
    metadataSearchObject.sort = {
      fieldName: sort[0].field,
      order: sort[0].dir.toUpperCase(),
    };
  }
  metadataSearchObject.searchCriteria.push({
    condition: 'EQUALS',
    field1: {
      name: 'doc_repo.is_latest',
      value: [true],
    },
  });
  // console.log(metadataSearchObject);
  return metadataSearchObject;
}
